module.exports = __webpack_public_path__ + "media/features/interval-training-analysis-4043ac07.jpg";